/* eslint-disable camelcase */
import { handleActions } from 'redux-actions';
import {
  metaSiteSettingsFetchInitialized,
  metaSiteSettingsFetchSucceeded,
  metaSiteSettingsFetchFailed,
  metaSiteSettingsUpdateSucceeded,
  metaSiteIntegrityFetchSucceeded,
} from '../../../MetaSites';

const inUnderMetaSiteDetailsRoute = new RegExp('/meta-sites/(.*)');

interface MetaSitesSettingsAttributes {
  name: string
  currency:string
  timezone:string
  created_at:string
  updated_at:string
  organization:string
  e_commerce_tracking: boolean
  sharepoint_integration:boolean
  cnil: boolean
}

export interface MetaSiteSettingsState {
  isLoading: boolean
  settings: {
    currencyValid: boolean
    timezoneValid: boolean
    type: string
    id: string
    attributes: MetaSitesSettingsAttributes
  }
  failed: boolean
}


const initialState: MetaSiteSettingsState = {
  isLoading: true,
  failed: false,
  settings: {
    currencyValid: true,
    timezoneValid: true,
    type: '',
    id: '',
    attributes: {
      name: '',
      currency: '',
      timezone: '',
      created_at: '',
      updated_at: '',
      organization: '',
      e_commerce_tracking: false,
      sharepoint_integration: false,
      cnil: false,
    },
  },
};

const reducer = handleActions<MetaSiteSettingsState, any>({
  [metaSiteSettingsFetchInitialized.toString()]: state => ({
    ...state,
    failed: false,
    isLoading: true,
    settings: {
      ...state.settings,
      currencyValid: true,
      timezoneValid: true,
    },
  }),
  [metaSiteSettingsFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    settings: {
      ...state.settings,
      ...payload.data,
    },
  }),
  [metaSiteSettingsFetchFailed.toString()]: state => ({
    ...state,
    failed: true,
    isLoading: false,
  }),
  [metaSiteSettingsUpdateSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    settings: {
      ...state.settings,
      attributes: {
        ...state.settings.attributes,
        ...payload,
      },
    },
  }),
  [metaSiteIntegrityFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    settings: {
      ...state.settings,
      currencyValid: payload.data.attributes.valid_currency,
      timezoneValid: payload.data.attributes.valid_timezone,
    },
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!inUnderMetaSiteDetailsRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
